import { cn } from './listingCardUtils.js';

export default function ListingCardBody({ children, variant = 'content', className }) {
  return (
    <div
      className={cn(
        'min-w-0',
        variant === 'hero' ? 'relative z-10 flex min-h-[260px] flex-col justify-end p-5 text-white' : 'space-y-2',
        variant === 'text' ? 'inline min-w-0' : '',
        variant === 'chip' ? 'inline-flex items-center gap-2' : '',
        variant === 'row' ? 'flex-1 space-y-0.5' : '',
        variant === 'content' ? 'space-y-2 px-4 pb-4 pt-8' : '',
        variant === 'directory' ? 'space-y-2 px-4 pb-4 pt-8' : '',
        className,
      )}
    >
      {children}
    </div>
  );
}
